import { Component, Input } from '@angular/core';

@Component({
	selector: 'sn-warning',
	template: require('./sn-warning.html')
})
export class SnWarningComponent {
	@Input() warningClass: string;
	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/components/common/sn-warning/sn-warning.ts